export interface AnimationStylePreset {
  id: string;
  label: string;
  fragment: string;
}

export const MAX_LIVE_ACTION_PROMPT_CHARS = 4000;

export const ANIMATION_STYLE_PRESETS: AnimationStylePreset[] = [
  {
    id: 'anime',
    label: 'Anime',
    fragment: 'anime style, bold outlines, cel-shaded colors',
  },
  {
    id: 'hand-drawn',
    label: 'Hand-drawn',
    fragment: 'hand-drawn 2D animation, expressive line work',
  },
  {
    id: 'watercolor',
    label: 'Watercolor',
    fragment: 'soft watercolor textures and pastel colors',
  },
  {
    id: 'comic',
    label: 'Comic book',
    fragment: 'comic-book style, strong ink lines, halftone shading',
  },
  {
    id: 'storybook',
    label: 'Storybook',
    fragment: 'storybook illustration style, warm pastel palette',
  },
  {
    id: 'flat-vector',
    label: 'Flat vector',
    fragment: 'flat vector animation, clean shapes, minimal shading',
  },
  {
    id: 'classic-2d',
    label: 'Classic 2D Cartoon',
    fragment:
      'classic 2D cartoon style, rounded characters, hand-painted backgrounds',
  },
  {
    id: 'modern-flat-2d',
    label: 'Modern Flat 2D',
    fragment: 'modern flat 2D style, clean geometry, bold flat colors',
  },
  {
    id: 'rubber-hose',
    label: 'Rubber Hose Cartoon',
    fragment:
      'rubber hose cartoon style, 1930s animation, noodle limbs, pie-cut eyes',
  },
  {
    id: 'cutout',
    label: 'Cutout Animation',
    fragment:
      'cutout animation style, layered paper shapes, deliberate jointed movement',
  },
  {
    id: 'retro-2d',
    label: 'Retro 2D Cartoon',
    fragment: 'retro 2D cartoon style, vintage TV colors, subtle grain',
  },
];

/** The selected style is applied automatically; extra text is optional. */
export function composeAnimationPrompt(
  style: AnimationStylePreset | null,
  extraDirection: string
): string {
  return [style?.fragment, extraDirection.trim()].filter(Boolean).join(', ');
}
